import styled from 'styled-components';
import { zIndex } from '@styles/zIndex.styles';
import { device } from '@styles/tools/breakpoints.styles';
import { FloatingMenu } from '@agilize/components-core';

export const StyledHeader = styled.div`
  overflow: inherit;
  align-items: center;
  display: flex;
  position: fixed;
  width: 100%;
  left: 0;
  z-index: ${zIndex.header};
  background: ${props => props.theme.colors.purple700};
  padding-left: 0;
  padding: ${props => props.theme.global.gutterSpace / 2}px 0;

  ${device.desktop} {
    box-shadow: ${props => (props.active ? `1px 0 4px ${props => props.theme.colors.grey400}` : 'unset')};
  }

  ${device.mobile} {
    padding: 0;
  }
`;

export const WhiteButton = styled.div`
  display: inline-flex;
  background: ${props => props.theme.colors.white};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  transition: transform ease-in-out 0.2s, margin-left ease-in-out 0.2s;
  transform: ${props => (props.active ? 'scaleX(-1)' : 'scaleX(1)')};
  position: fixed;
  top: 6px;
  left: 11px;
  z-index: ${zIndex.openMenu};

  ${device.desktop} {
    display: none;
  }
`;

export const User = styled.div`
  padding-right: ${props => props.theme.global.gutterSpace}px;
  max-width: 160px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: ${props => props.theme.colors.white};
  font-size: ${props => props.theme.fontSizes[2]};
`;

export const HelpDeskText = styled.div`
  padding-right: ${props => props.theme.global.gutterSpace}px;
  color: ${props => props.theme.colors.white};
  font-size: ${props => props.theme.fontSizes[2]};
  margin-right: ${props => props.theme.global.gutterSpace * 0.5}px;
  &:hover {
    text-decoration: underline;
  }
`;
